import { render, staticRenderFns } from "./ReceipesRegular.vue?vue&type=template&id=9ea64d00&scoped=true&"
import script from "./ReceipesRegular.vue?vue&type=script&lang=js&"
export * from "./ReceipesRegular.vue?vue&type=script&lang=js&"
import style0 from "./ReceipesRegular.vue?vue&type=style&index=0&id=9ea64d00&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9ea64d00",
  null
  
)

export default component.exports